import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=a2d4472e&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=a2d4472e&prod&lang=css"
import style1 from "./Aside.vue?vue&type=style&index=1&id=a2d4472e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d4472e",
  null
  
)

export default component.exports